import { useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { getAcademyBilledCourseQuery } from 'modules/academies/graphql/queries';

export default function useBilledCourse({ courseId }) {
  const { data, loading, error } = useQuery(getAcademyBilledCourseQuery, {
    variables: { courseId },
    skip: !courseId,
  });
  const course = useMemo(() => data?.course || {}, [data]);

  return {
    course,
    loading,
    error: getErrorMessage({ error }),
  };
}
